import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a icn/services/billofmaterials
 * @param {*} state
 * @param {*} action
 */
export default function icnBomListReducer(state = initialState.icnBomListSearch, action){

    switch(action.type)
    {
        case types.GET_BOMLIST_REQUEST:
            return {...state, list: [], item: null, error: null, isSearching: true};
        case types.GET_BOMLIST_SUCCESS:
            return {...state, list: action.data, error: null, isSearching: false};
        case types.GET_BOMLIST_ERROR:
            return {...state, list: [], error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/icnBomListReducer.js